// extracted by mini-css-extract-plugin
export default {"dots":"ActionButtons_dots__bVrUq"};